interface DecorPreviewProps {
  readonly color: string;
}
export function DecorPreview({
  color
}: DecorPreviewProps) {
  return <div className="relative w-full h-full">
      {/* Base dark layer */}
      <div className="absolute inset-0 bg-[#0a0a12]" />
      
      {/* Radial halo effect - main color glow */}
      {color && <div className="absolute inset-0 transition-all duration-300" style={{
      background: `
              radial-gradient(
                ellipse 120% 90% at 50% 40%,
                ${color} 0%,
                ${color}cc 30%,
                ${color}66 55%,
                ${color}33 75%,
                transparent 100%
              )
            `
    }} />}
      
      {/* Vignette effect for depth - stronger at bottom */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: `
            radial-gradient(
              ellipse 100% 80% at 50% 40%,
              transparent 40%,
              rgba(0, 0, 0, 0.15) 70%,
              rgba(0, 0, 0, 0.4) 90%,
              rgba(0, 0, 0, 0.6) 100%
            )
          `
    }} />
      
      {/* Bottom halo accent */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: `
            linear-gradient(
              to top,
              rgba(0, 0, 0, 0.5) 0%,
              rgba(0, 0, 0, 0.25) 20%,
              transparent 45%
            )
          `
    }} />
      
      {/* Subtle noise texture overlay */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`
    }} />
      
      {/* PNG overlay image - scaled to fit fully */}
      <div className="absolute inset-0 flex items-center justify-center">
        <img alt="Aperçu du décor" className="w-[92%] h-full object-contain" src="/lovable-uploads/251d1bac-a48f-4ec1-84b0-3f01a8dee296.png" />
      </div>
    </div>;
}